import { IBlogPageViewModel } from 'Types/Litium';

interface BlogLeftNavigationProps {
    expandMainBlogItemBodyText: IBlogPageViewModel['expandMainBlogItemBodyText'];
    navigationHeaderImage: IBlogPageViewModel['navigationHeaderImage'];
    missionAndVisionPageLink: IBlogPageViewModel['missionAndVisionPageLink'];
    thisWeeksAuthorsThumbnail: IBlogPageViewModel['thisWeeksAuthorsThumbnail'];
    navigationTopLevelLinkList?: IBlogPageViewModel['navigationTopLevelLinkList'];
    navigationBlogItemLinkList?: IBlogPageViewModel['navigationBlogItemLinkList'];
    blogHomeLink: IBlogPageViewModel['blogHomeLink'];
    navigationBlogItemListHeaderText: IBlogPageViewModel['navigationBlogItemListHeaderText'];
    archiveActionLink: IBlogPageViewModel['archiveActionLink'];
    allAuthorsActionLink: IBlogPageViewModel['allAuthorsActionLink'];
    thisWeeksAuthorHeaderText: IBlogPageViewModel['thisWeeksAuthorHeaderText'];
}

const BlogLeftNavigation = ({
    expandMainBlogItemBodyText,
    navigationHeaderImage,
    missionAndVisionPageLink,
    thisWeeksAuthorsThumbnail,
    navigationTopLevelLinkList,
    navigationBlogItemLinkList,
    blogHomeLink,
    navigationBlogItemListHeaderText,
    archiveActionLink,
    allAuthorsActionLink,
    thisWeeksAuthorHeaderText,
}: BlogLeftNavigationProps) => (
    <ul className="mr-[100px] hidden min-w-[20%] flex-col py-4 lg:flex">
        <li
            className="bg-cover pb-1 pl-4 pt-3"
            style={
                {
                    'background-image': `url(${navigationHeaderImage.src})`,
                } as React.CSSProperties
            }
        >
            <a
                className="font-montserrat text-base font-medium uppercase"
                href={blogHomeLink.href}
            >
                {blogHomeLink.text}
            </a>
        </li>

        {missionAndVisionPageLink && (
            <li className="mb-4 ml-8">
                <a
                    className="w-full font-montserrat text-base font-medium"
                    href={missionAndVisionPageLink.href}
                >
                    {missionAndVisionPageLink.text}
                </a>
            </li>
        )}

        {navigationBlogItemLinkList?.length > 0 && (
            <li className="mb-3 ml-4">
                <span className="font-montserrat text-base font-medium uppercase">
                    {navigationBlogItemListHeaderText}
                </span>

                <ul>
                    {navigationBlogItemLinkList?.map((item, index) => (
                        <li className="mb-3 ml-4" key={index}>
                            <a
                                className="text-ellipsis font-montserrat text-base font-medium leading-5"
                                href={item.href}
                            >
                                {item.text}
                            </a>
                        </li>
                    ))}

                    <li className="ml-4">
                        <a
                            className="font-montserrat text-base font-medium uppercase"
                            href={archiveActionLink.href}
                        >
                            {archiveActionLink.text}
                        </a>
                    </li>
                </ul>
            </li>
        )}

        {navigationTopLevelLinkList?.length > 0 && (
            <li className="mb-3 ml-4">
                <ul className="mt-2">
                    {navigationTopLevelLinkList?.map((item, index) => (
                        <li key={index}>
                            <a
                                className="font-montserrat text-base font-medium uppercase"
                                href={item.href}
                            >
                                {item.text}
                            </a>
                        </li>
                    ))}
                </ul>
            </li>
        )}

        <li className="mb-3 ml-4">
            <a
                className="font-montserrat text-base font-medium uppercase"
                href={allAuthorsActionLink.href}
            >
                {allAuthorsActionLink.text}
            </a>
        </li>

        {thisWeeksAuthorsThumbnail && (
            <li className="ml-4 mt-7">
                <a
                    className="flex flex-col font-montserrat text-base font-medium"
                    href={thisWeeksAuthorsThumbnail.url}
                >
                    <span className="font-montserrat text-base font-medium uppercase">
                        {thisWeeksAuthorHeaderText}
                    </span>

                    <img
                        className="mb-3 mt-5 h-32  w-32 rounded-full border-[5px] border-solid border-white"
                        src={thisWeeksAuthorsThumbnail.thumbnailImage.src}
                        alt={thisWeeksAuthorsThumbnail.thumbnailImage.altText}
                        width={
                            thisWeeksAuthorsThumbnail.thumbnailImage.width > 0
                                ? thisWeeksAuthorsThumbnail.thumbnailImage.width
                                : ''
                        }
                        height={
                            thisWeeksAuthorsThumbnail.thumbnailImage.height > 0
                                ? thisWeeksAuthorsThumbnail.thumbnailImage
                                      .height
                                : ''
                        }
                    />

                    <span className="font-roboto text-sm font-medium uppercase">
                        {thisWeeksAuthorsThumbnail.thumbnailHeaderText}
                    </span>

                    <span className="mb-5 font-roboto text-sm font-normal">
                        {thisWeeksAuthorsThumbnail.thumbnailDescription}
                    </span>

                    <span className="font-roboto text-sm font-medium">
                        {expandMainBlogItemBodyText}
                    </span>
                </a>
            </li>
        )}
    </ul>
);

export default BlogLeftNavigation;
